<template>
  <el-dialog title="批量导出" :visible.sync="dialogVisible" width="600px" :before-close="handleClose" :close-on-click-modal="false" center>
    <div class="form-body">
      <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="auto" class="demo-ruleForm">
        <el-form-item label="导出参数" prop="name">
          <el-select v-model="ruleForm.name" placeholder="请选择导出参数" style="width:100%;">
            <el-option v-for="(item,index) in itemList" :key="index" :label="item.name" :value="item.name"/>
          </el-select>
        </el-form-item>
        <el-form-item label="日期范围" prop="createdAt">
          <el-date-picker type="daterange" placeholder="选择日期范围" value-format="yyyy-MM-dd" format="yyyy-MM-dd" v-model="ruleForm.createdAt" style="width: 250px" clearable/>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      ruleForm: {
        name: null,
        createdAt: null
      },
      rules: {
        name: [
          {
            required: true,
            message: "请设置导出参数",
            trigger: "blur",
          }
        ],
        createdAt: [
          {
            required: true,
            message: "请选择日期范围",
            trigger: "blur",
          }
        ]
      },
      itemList: [],
    };
  },
  computed: {
    ...mapState(["buttonTextColor"]),
  },
  props: ["dialogVisible","currentGroup","currentDevice"],
  watch: {
    dialogVisible(newValue) {
      if (newValue) {
        this.loadParams();
      }
    },
  },
  methods: {
    onInput() {
      this.$forceUpdate();
    },
    loadParams() {
        var params={
        "deviceId":this.currentDevice.deviceId,
        "groupName":this.currentGroup,
      }
      this.request.deviceParams(params).then((res) => {
        if (res.code == 0) {
          this.itemList=res.data;
        }
      });
    },
    handleClose() {
      this.ruleForm = {
        name: null,
        createdAt: null
      };
      this.$emit("viewClose");
    },
    submit() {
      if (this.ruleForm.name==null||this.ruleForm.createdAt==null) {
        this.$message.error("请设置正确的参数");
      } else {
        this.$refs["ruleForm"].validate((valid) => {
          if (valid) {
            var param={
              "deviceId": this.currentDevice.deviceId,
              "name": this.ruleForm.name,
              "createdAt": this.ruleForm.createdAt
            };
            this.request.exportParam(param).then((res) => {
               if (!res || !res.data) {
                that.$message({
                  type: "error",
                  message: "下载失败",
                });
              } else if (res.data.size < 100) {
                var reader = new FileReader();
                reader.onload = function () {
                  var json = JSON.parse(reader.result);
                  that.$message({
                    type: "error",
                    message: json.msg,
                  });
                };
                reader.readAsText(new Blob([res.data]));
              } else {
                const blob = new Blob([res.data], {
                  type: "application/vnd.ms-excel",
                });
                const filename = res.headers["content-disposition"]
                  .split(";")[1]
                  .split("filename=")[1];
                if ("download" in document.createElement("a")) {
                  // 非IE下载
                  const link = document.createElement("a");
                  const blob = new Blob([res.data], {
                    type: "application/vnd.ms-excel",
                  });
                  link.style.display = "none";
                  link.href = URL.createObjectURL(blob);
                  link.setAttribute("download", decodeURIComponent(filename));
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                } else {
                  // IE10+下载
                  navigator.msSaveBlob(blob, decodeURIComponent(filename));
                }
              }
            });
          }
        });
      }
    },
  },
};
</script>
<style scoped>
.form-body {
  width:550px;
  display:flex;
  flex-direction:row;
  justify-content:center;
  box-sizing:border-box;
}
</style>